<template>
    <el-main class="node-container ">
        <div class="search">
            <el-form :inline="true" :model="query" class="demo-form-inline">
                <el-form-item>
                    <el-button-group>
                        <el-button type="danger" icon="el-icon-plus" @click="$refs.editForm.showDrawer('', 'add')">添加</el-button>
                    </el-button-group>
                </el-form-item>
                <el-form-item label="节点编号">
                    <el-input v-model="query.id" placeholder="节点编号" clearable></el-input>
                </el-form-item>
                <el-form-item label="节点名称">
                    <el-input v-model="query.title" placeholder="节点名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="节点路由">
                    <el-input v-model="query.title" placeholder="节点名称" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search">搜索</el-button>
                </el-form-item>
            </el-form>
        </div>

        <div class="node-box">
            <el-collapse>
                <el-collapse-item :name="tree.id" v-for="(tree, index) in treeData" :key="index">
                    <template slot="title">
                        <div class="node-colp-head">
                            <div class="node-colp-title">{{ tree.label }}</div>
                            <div class="node-colp-more">
                                <el-link :underline="false" @click.stop="edit(tree, 'update')">编辑</el-link>
                                <el-link :underline="false" style="margin-left: 10px" @click.stop="remove(tree)">删除</el-link>
                            </div>
                        </div>
                    </template>
                    <div class="node-type">菜单项</div>
                    <div class="node-colp-item">
                        <div class="node-colp-content" v-for="(node, index) in tree.children" :key="index">
                            <el-dropdown placement="top-end" trigger="click">
                                <div class="left-title">{{ node.label }}</div>
                                <el-dropdown-menu slot="dropdown">
                                    <div class="el-dropdown-menu__item" @click="edit(node, 'update')">编辑</div>
                                    <div class="el-dropdown-menu__item" @click="remove(node)">删除</div>
                                </el-dropdown-menu>
                            </el-dropdown>
                            <div class="node-colp-right">
                                <div class="content-item" v-for="(item, index) in node.children" :key="index">
                                    <el-dropdown placement="top-end" trigger="click">
                                        <el-link :underline="false" class="right-item">{{ item.label }}</el-link>
                                        <el-dropdown-menu slot="dropdown">
                                            <div class="el-dropdown-menu__item" @click="edit(item, 'update')">编辑</div>
                                            <div class="el-dropdown-menu__item" @click="remove(item)">删除</div>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-collapse-item>
            </el-collapse>
        </div>

        <!-- <div class="tree" style="width: 60%">
            <el-tree :data="treeData" node-key="id" default-expand-all :expand-on-click-node="false" width="50%">
                <span class="custom-tree-node" slot-scope="{ node, data }">
                    <span>{{ node.label }}</span>
                    <span>
                        <el-button type="text" size="mini" @click="$refs.editForm.showDrawer(data, 'add')"> 添加 </el-button>
                        <el-button type="text" size="mini" @click="$refs.editForm.showDrawer(data, 'update')"> 编辑 </el-button>
                        <el-button type="text" size="mini"> 删除 </el-button>
                    </span>
                </span>
            </el-tree>
        </div> -->
        <editForm ref="editForm" v-on:getTreeData="getTreeData"></editForm>
    </el-main>
</template>
<script>
let id = 1000;
import editForm from './edit';

export default {
    components: {
        editForm
    },
    data() {
        return {
            query: {
                keyword: ''
            },
            treeData: [],
        };
    },
    created: function () {
        this.getTreeData();
    },
    methods: {
        // 获取节点数据
        getTreeData() {
            let that = this;
            let url = '/api/auth.node/tree';
            let query = this.query;
            this.$post(url, query).then(function (response) {
                let result = response.data;
                that.treeData = result.tree;
            });
        },
        edit(options, type) {
            this.$refs['editForm'].showDrawer(options, type);
        },
        remove(data) {
            let that = this;
            let url = '/api/auth.node/delete';
            let query = {
                id: data.id
            };
            that.$confirm('确定删除该节点吗？', '提示', {})
                .then(() => {
                    this.$post(url, query).then(function (res) {
                        if (res.code == 200) {
                            that.$message.success(res.msg);
                            that.getTreeData();
                        } else {
                            that.$message.error(res.msg);
                        }
                    });
                })
                .catch(() => {
                    that.$message('已取消');
                });
        }
    }
};
</script>
<style>

.table-100 {
    width: 100%;
}

.custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
}
</style>
<style scoped>
.node-container{
  height: 100%;
  padding: 12px;
}
.node-colp-head {
    display: flex;
    width: 100%;
}

.node-type{
    padding-left: 8px;
}

.node-colp-item {
    display: flex;
    flex-wrap: wrap;
}

.node-colp-content {
    padding-left: 8px;
    padding-top: 5px;
    flex: 0 25%;
    border-right: 1px solid #ebedf0;
    border-top: 1px solid #ebedf0;
    box-sizing: border-box;
}

.node-colp-content:nth-child(4n + 0) {
    border-right: none;
}

.node-colp-content:last-child {
    flex: 1;
    border-right: none;
    width: 100%;
    min-width: 100%;
    max-width: 100%;
}

.node-colp-title {
    width: 5rem;
}

.node-colp-more {
    flex: 1;
    text-align: end;
}

.node-colp-left {
    flex: 20%;
    white-space: normal;
}

.left-title {
    cursor: pointer;
}

.node-colp-right {
    display: flex;
    flex-wrap: wrap;
}

.content-item {
    flex: 0 20%;
}

.right-item {
    color: #409eff;
}
</style>
